import { ActionTree } from "vuex";
import { CustomerState } from "@/store/customer/type";
import { RootState } from "@/store/type";
import Api from "@/api/Api";
import { CustomerMutations } from "@/store/customer/mutations";
import Uicookie from "@/utils/cookie";
import { Customer } from "@/models/customer";
import { ShoppingCart } from "@/models/shopping";

export const actions: ActionTree<CustomerState, RootState> = {
  getMe: ({ commit }): Promise<Customer | null> | null => {
    const userToken = Uicookie.getCustomerToken();
    if (userToken) {
      return Api.account.getProfile(userToken)
        .then((data: Customer) => {
          commit(CustomerMutations.SET_CUSTOMER_TOKEN, data);
          return data;
        })
        .catch((e) => {
          console.error(e);
          return null;
        });
    }
    return null;
  },

  getCart: ({ commit, state }): ShoppingCart | Promise<ShoppingCart> | null => {
    const currentCartId = Uicookie.getCart();
    const userToken = Uicookie.getCustomerToken();
    const me = state.me;

    if (userToken && (me && me.shoppingCart)) {
      commit(CustomerMutations.SET_CUSTOMER_CART, me.shoppingCart);
      if (me.shoppingCart) {
        Uicookie.setCart(me.shoppingCart.id);
        return me.shoppingCart;
      }
    } else if (currentCartId) {
      if (state.cart) {
        return state.cart;
      } else {
        Api.cart.getAnonymousCart(currentCartId)
          .then((data: ShoppingCart) => {
            commit(CustomerMutations.SET_CUSTOMER_CART, data);
            return data;
          })
          .catch((e) => {
            commit(CustomerMutations.SET_CUSTOMER_CART, null);
            Uicookie.deleteCart();
            return null;
          });
      }
    }
    return null;
  },

  setCart: ({ commit }, data: ShoppingCart) => {
    commit(CustomerMutations.SET_CUSTOMER_CART, data);
    return data;
  },

  setCustomer: ({ commit }, data: Customer) => {
    commit(CustomerMutations.SET_CUSTOMER, data);
    return data;
  },

  removeCustomerAddress({ commit }, addressName) {
    commit(CustomerMutations.REMOVE_CUSTOMER_ADDRESS, addressName);

  },

  addCustomerAddress({ commit }, { isNew, address }) {
    commit(CustomerMutations.ADD_CUSTOMER_ADDRESS, { isNew, address });

  },

  loginCustomer: ({ commit }, customer: Customer) => {
    commit(CustomerMutations.SET_CUSTOMER_TOKEN, customer);
  },

  logOutCustomer: ({ commit }) => {
    commit(CustomerMutations.LOGOUT_CUSTOMER);
  },
};